export enum ShareStatus {
  Active = 1,
  Inactive = 2,
}
